import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetIdiomasEnAPI, ModificarLicenciaEnAPI, ObtenerLicenciasInfoEnAPI, VersionesInfoEnAPI, ProgramasEnAPI, DisenyosInfoEnAPI, CrearLicenciaInfoEnAPI, ModificarLicenciaInfoEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, traducirPagina } from '../../librerias/funciones'
import {
    SaveOutlined,
    CloseOutlined
} from '@ant-design/icons';

import { Input, Row, Col, Drawer, Tabs, Checkbox } from 'antd';
const { TabPane } = Tabs;

const FichaClienteData = ({ props, configApp }) => {
    const [programas, setProgramas] = React.useState([]);
    const [versiones, setVersiones] = React.useState([]);
    const [disenyos, setDisenyos] = React.useState([]);


    const [bloqueoPantalla, setBloqueoPantalla] = React.useState({ LOADER: false, MENSAJE: "" })


    const [hayRegistros, setHayRegistros] = React.useState(false);
    const [idiomasLocal, setIdiomasLocal] = React.useState([]);
    const [textoIdioma, setTextoIdioma] = React.useState(1);
    const [ID_LICENCIA, setID_LICENCIA] = React.useState(0);
    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: null,
            USUARIO: "",
            PWD: "",
            ID_SOCIO: 0,
            ID_IDIOMA: 1,
            ID_TALLER: 0,
            CORREO_RECUPERACION_PWD: "",
            OBSERVACIONES: "",
            NOMBRE_TALLER: "",
            ID_PROGRAMA: 0,
            ID_VERSION: 0,
            ID_DISENYO: 0,
            PROVIENE_RED: false,


            DISENYO_ESPECIAL: "",
            CIF_TALLER: "",
            NOMBRE_RED: ""
        }
    )





    const BuscarUsuariosEnAPI = (ID, ID_SOCIO) => {
        ObtenerLicenciasInfoEnAPI(1, 1, 1, "A", ID_SOCIO, ID, null, false).then((cli) => {
            if (cli.REGISTROS !== undefined)
                if (cli.REGISTROS !== null && cli.REGISTROS.length > 0) {
                    let user = cli.REGISTROS[0];
                    setTextoIdioma(user.ID_IDIOMA);
                    setID_LICENCIA(user.ID);
                    payLoadLocal.USUARIO = user.USUARIO
                    payLoadLocal.PWD = user.PWD
                    payLoadLocal.ID_SOCIO = user.ID_SOCIO
                    payLoadLocal.ID_IDIOMA = user.ID_IDIOMA
                    payLoadLocal.ID_TALLER = user.ID_TALLER
                    payLoadLocal.CORREO_RECUPERACION_PWD = user.CORREO_RECUPERACION_PWD
                    payLoadLocal.OBSERVACIONES = user.OBSERVACIONES
                    payLoadLocal.NOMBRE_TALLER = user.NOMBRE_TALLER
                    payLoadLocal.ID_PROGRAMA = user.ID_PROGRAMA
                    payLoadLocal.ID_VERSION = user.ID_VERSION
                    payLoadLocal.ID_DISENYO = user.ID_DISENYO

                    payLoadLocal.PROVIENE_RED = user.PROVIENE_RED


                    payLoadLocal.DISENYO_ESPECIAL = user.DISENYO_ESPECIAL
                    payLoadLocal.ID = user.ID

                    payLoadLocal.NOMBRE_RED = user.NOMBRE_RED

                    Versiones(user.ID_PROGRAMA);
                    Disenyos(user.ID_PROGRAMA);


                    setPayLoadLocal({ ...payLoadLocal })
                }
        })
    }



    const Programas = async () => {
        let PROGRAMAS = await ProgramasEnAPI()
        if (PROGRAMAS !== undefined && PROGRAMAS !== null && PROGRAMAS.REGISTROS !== null && PROGRAMAS.REGISTROS.length > 0) {
            setProgramas(PROGRAMAS.REGISTROS)


        } else {
            setProgramas(null)
        }
    }


    const Versiones = async (ID_PROGRAMA) => {
        setVersiones([])

        let VERSIONES = await VersionesInfoEnAPI(ID_PROGRAMA)
        if (VERSIONES !== undefined && VERSIONES !== null && VERSIONES.REGISTROS !== null && VERSIONES.REGISTROS.length > 0) {
            setVersiones(VERSIONES.REGISTROS)
        } else {
            setVersiones(null)
        }


    }


    const Disenyos = async (ID_PROGRAMA) => {
        setDisenyos([])
        let DISEÑOS = await DisenyosInfoEnAPI(ID_PROGRAMA)
        if (DISEÑOS !== undefined && DISEÑOS !== null && DISEÑOS.REGISTROS !== null && DISEÑOS.REGISTROS.length > 0) {
            setDisenyos(DISEÑOS.REGISTROS)
        } else {
            setDisenyos(null)
        }


    }



    if (!hayRegistros && props.ESTADO_FICHA) {
        setHayRegistros(true);
        //Programas();



        //CLIENTE SELECCIONADO
        if (Object.keys(props.DATOS_CLIENTE).length > 0) {

            payLoadLocal.ID_TALLER = props.DATOS_CLIENTE.Codigo;
            payLoadLocal.NOMBRE_TALLER = props.DATOS_CLIENTE.Razon;


            setPayLoadLocal(payLoadLocal)
        } else {
            BuscarUsuariosEnAPI(props.ID_USUARIO, props.ID_SOCIO)
        }


        GetIdiomasEnAPI().then(idiomas => {
            if (idiomas !== undefined) {
                if (idiomas !== null && idiomas.length > 0) {
                    setIdiomasLocal(idiomas)

                } else {
                    setIdiomasLocal(null)
                }
            }
        })


        if (props.ID_SOCIO !== undefined && props.ID_SOCIO !== null && props.ID_SOCIO === 73) {


            Versiones(null);
            Disenyos(null);

        }



    } else {
        if (!props.ESTADO_FICHA && hayRegistros) {
            setHayRegistros(false);
            setIdiomasLocal([])
            setTextoIdioma(1)
            setPayLoadLocal({
                ID: null,
                USUARIO: "",
                PWD: "",
                ID_SOCIO: 0,
                ID_IDIOMA: 1,
                ID_TALLER: 0,
                CORREO_RECUPERACION_PWD: "",
                OBSERVACIONES: "",
                NOMBRE_TALLER: "",
                ID_PROGRAMA: 0,
                ID_VERSION: 0,
                ID_DISENYO: 0,
                PROVIENE_RED: false,
                DISENYO_ESPECIAL: "",
                CIF_TALLER: "",
                NOMBRE_RED: ""

            })
        }
    }

    const guardarEstadoFormulario = (e) => {

        const USUARIO = e.target.name === 'USUARIO' ? e.target.value : payLoadLocal.USUARIO;
        const PWD = e.target.name === 'PWD' ? e.target.value : payLoadLocal.PWD;
        const ID_SOCIO = e.target.name === 'ID_SOCIO' ? e.target.value : payLoadLocal.ID_SOCIO;
        const ID_IDIOMA = e.target.name === 'ID_IDIOMA' ? parseInt(e.target.value) : payLoadLocal.ID_IDIOMA;
        const ID_TALLER = e.target.name === 'ID_TALLER' ? parseInt(e.target.value) : payLoadLocal.ID_TALLER;

        const CORREO_RECUPERACION_PWD = e.target.name === 'CORREO_RECUPERACION_PWD' ? e.target.value : payLoadLocal.CORREO_RECUPERACION_PWD;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES;
        const NOMBRE_TALLER = e.target.name === 'NOMBRE_TALLER' ? e.target.value : payLoadLocal.NOMBRE_TALLER;



        const ID_PROGRAMA = e.target.name === 'ID_PROGRAMA' ? parseInt(e.target.value) : payLoadLocal.ID_PROGRAMA;
        const ID_VERSION = e.target.name === 'ID_VERSION' ? parseInt(e.target.value) : payLoadLocal.ID_VERSION;

        const ID_DISENYO = e.target.name === 'ID_DISENYO' ? parseInt(e.target.value) : payLoadLocal.ID_DISENYO;
        const PROVIENE_RED = e.target.name === 'PROVIENE_RED' ? e.target.checked : payLoadLocal.PROVIENE_RED;
        const NOMBRE_RED = e.target.name === 'NOMBRE_RED' ? e.target.value : payLoadLocal.NOMBRE_RED;




        payLoadLocal.USUARIO = USUARIO
        payLoadLocal.PWD = PWD
        payLoadLocal.ID_SOCIO = ID_SOCIO
        payLoadLocal.ID_IDIOMA = ID_IDIOMA
        payLoadLocal.ID_TALLER = ID_TALLER
        payLoadLocal.CORREO_RECUPERACION_PWD = CORREO_RECUPERACION_PWD
        payLoadLocal.OBSERVACIONES = OBSERVACIONES
        payLoadLocal.NOMBRE_TALLER = NOMBRE_TALLER
        payLoadLocal.ID_PROGRAMA = ID_PROGRAMA
        payLoadLocal.ID_VERSION = ID_VERSION
        payLoadLocal.ID_DISENYO = ID_DISENYO
        payLoadLocal.PROVIENE_RED = PROVIENE_RED
        payLoadLocal.NOMBRE_RED = NOMBRE_RED



        setPayLoadLocal({ ...payLoadLocal })
    }

    const modificarIdioma = (e) => {
        payLoadLocal.ID_IDIOMA = e;

        setPayLoadLocal(payLoadLocal)
        setTextoIdioma(e)
    }


    const crearUsuario = () => {
        payLoadLocal.ID_SOCIO = props.ID_SOCIO;
        let PAYLOAD = { ...payLoadLocal }
        //  PAYLOAD.ID = Object.keys(props.DATOS_CLIENTE).length > 0 ? 0 : props.ID_USUARIO;


        if (Object.keys(props.DATOS_CLIENTE).length > 0) {
            PAYLOAD.CIF_TALLER = props.DATOS_CLIENTE.Cif;
            PAYLOAD.RAZON = props.DATOS_CLIENTE.Razon;
            PAYLOAD.DIRECCION = "";
            PAYLOAD.CODIGO_POSTAL = "";
            PAYLOAD.POBLACION = props.DATOS_CLIENTE.Poblacion;
            PAYLOAD.PROVINCIA = "";
            PAYLOAD.PAIS = props.DATOS_CLIENTE.PAIS_LOCAL;
            PAYLOAD.MAIL = payLoadLocal.CORREO_RECUPERACION_PWD;
            PAYLOAD.TELEFONO = props.DATOS_CLIENTE.Telefono;
            PAYLOAD.EMPRESA_SOCIO = "";
            PAYLOAD.ID_SOCIO = props.ID_SOCIO;


            //crear
            bloqueoPantalla.LOADER = true; bloqueoPantalla.MENSAJE = "Esto puede tardar unos segundos, espere un momento por favor."; setBloqueoPantalla({ ...bloqueoPantalla })

            //console.log("pruebas",PAYLOAD,"props.DATOS_CLIENTE",props.DATOS_CLIENTE)

            CrearLicenciaInfoEnAPI(PAYLOAD).then(usuario => {
                bloqueoPantalla.LOADER = false; bloqueoPantalla.MENSAJE = ""; setBloqueoPantalla({ ...bloqueoPantalla })


                if (usuario !== undefined && usuario !== null && usuario.OK) {
                    MSGOK("Usuario creado correctamente.");

                    props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                    props.TEXTO_BUSCADOR("")
                    props.CERRAR_FICHA(false);

                    //SE LIMPIA EL CLIENTE SELECCIONADO
                    props.DATOS_CLIENTE_SELECCIONADO({})
                }

            })



        } else {
            bloqueoPantalla.LOADER = true; bloqueoPantalla.MENSAJE = "Esto puede tardar unos segundos, espere un momento por favor."; setBloqueoPantalla({ ...bloqueoPantalla })

            ModificarLicenciaInfoEnAPI(PAYLOAD).then(usuario => {

                bloqueoPantalla.LOADER = false; bloqueoPantalla.MENSAJE = ""; setBloqueoPantalla({ ...bloqueoPantalla })

                if (usuario !== undefined) {
                    if (usuario.OK) {
                        MSGOK("Usuario actualizado correctamente.")

                        props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                        props.TEXTO_BUSCADOR("")
                        props.CERRAR_FICHA(false);

                        //SE LIMPIA EL CLIENTE SELECCIONADO
                        props.DATOS_CLIENTE_SELECCIONADO({})
                    }
                }
            })
        }
    }

    return (

        <Drawer
            width={600}
            onClose={() => {
                if (!bloqueoPantalla.LOADER) {
                    props.CERRAR_FICHA(false);
                    props.DATOS_CLIENTE_SELECCIONADO({})
                }
            }}
            visible={props.ESTADO_FICHA}
            closable={false}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>




            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {

                        if (!bloqueoPantalla.LOADER) {

                            props.CERRAR_FICHA(false);
                            props.DATOS_CLIENTE_SELECCIONADO({})
                        }

                    }}></CloseOutlined>
                    <div> {props.title}</div>
                </div>
            </div>

            <div className="m-3">
                <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', height: (configApp.height - 140).toString() + "px", overflow: 'auto' }}>
                    <Col md={12}>
                        <span>{traducirPagina("Usuario")} </span>
                    </Col>
                    <Col md={12}>
                        <span>{traducirPagina("Contrasenia")} </span>
                    </Col>

                    <Col md={12}>
                        <Input name="USUARIO" autocomplete="off" value={payLoadLocal.USUARIO} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>
                    <Col md={12}>
                        <Input name="PWD" type="text" autocomplete="off" value={payLoadLocal.PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>


                    <Col md={24}>
                        <span>{traducirPagina("Idioma")} </span>
                    </Col>
                    <Col md={24}>
                        {idiomasLocal !== null ?
                            <select value={textoIdioma} className="custom-select" name={"ID_IDIOMA"}
                                onChange={(e) => { modificarIdioma(e.target.value); guardarEstadoFormulario(e) }}>
                                {idiomasLocal.length > 0 ?
                                    idiomasLocal.map((idioma) =>
                                        <option key={idioma.ID} value={idioma.ID}>{idioma.NOMBRE}</option>
                                    )
                                    :
                                    null
                                }
                            </select>
                            :
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <h4>{traducirPagina("Info_error_idioma")}</h4>
                            </div>
                        }
                    </Col>
                    <Col md={24}>
                        <span>{traducirPagina("Info_cliente_correo")}</span>
                    </Col>

                    <Col md={24}>
                        <Input name="CORREO_RECUPERACION_PWD" value={payLoadLocal.CORREO_RECUPERACION_PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24}>
                        <span>{traducirPagina("Observaciones")}</span>
                    </Col>

                    <Col md={24}>
                        <Input name="OBSERVACIONES" value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24}>
                        <span>{traducirPagina("Taller")} </span>
                    </Col>

                    <Col md={24}>
                        <Input disabled={true} name="NOMBRE_TALLER" type="text" autocomplete="off" value={payLoadLocal.NOMBRE_TALLER} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>


                    <Col md={24}>
                        <span>{traducirPagina("Red")} </span>
                    </Col>

                    <Col md={24}>
                        <Input disabled={true} name="NOMBRE_RED" type="text" autocomplete="off" value={payLoadLocal.NOMBRE_RED} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    {props.ID_SOCIO !== undefined && props.ID_SOCIO !== null && props.ID_SOCIO === 73 &&
                        <>


                            <Col md={24}>
                                <span>{traducirPagina("Version")} </span>
                            </Col>

                            <Col md={24}>
                                {versiones !== null ?
                                    <select disabled={versiones.length === 0} value={payLoadLocal.ID_VERSION} className="custom-select" name={"ID_VERSION"}
                                        onChange={(e) => { guardarEstadoFormulario(e) }}>
                                        <option value="0">{traducirPagina("Seleccion_version")}</option>

                                        {versiones.length > 0 ?
                                            versiones.map((version) =>
                                                <option key={version.ID} value={version.ID}>{version.NOMBRE}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <h4>{traducirPagina("Sin_resultados")}</h4>
                                    </div>
                                }
                            </Col>

                            <Col md={24}>
                                <span>{traducirPagina("Diseño")} </span>
                            </Col>

                            <Col md={24}>
                                {disenyos !== null ?
                                    <select disabled={disenyos.length === 0} value={payLoadLocal.ID_DISENYO} className="custom-select" name={"ID_DISENYO"}
                                        onChange={(e) => { guardarEstadoFormulario(e) }}>
                                        <option value="0">{traducirPagina("Seleccion_disenyo")}</option>

                                        {disenyos.length > 0 ?
                                            disenyos.map((disenyo) =>
                                                <option key={disenyo.ID} value={disenyo.ID}>{disenyo.DISENYO}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <h4>{traducirPagina("Sin_resultados")}</h4>
                                    </div>
                                }
                            </Col>
                        </>
                    }






                </Row>
                <div style={{ flexGrow: '6', textAlign: 'right' }} >
                    <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer', padding: '0px 20px' }} onClick={(e) => { crearUsuario() }}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Guardar_salir").toUpperCase()} </span>  </button>
                </div>
            </div>

            {bloqueoPantalla.LOADER ?
                <div className="pantallaBloqueo">
                    <div className="image-mask-info" style={{ fontSize: '18px' }}>
                        <div dangerouslySetInnerHTML={{ __html: bloqueoPantalla.MENSAJE }}>

                        </div>
                    </div>
                </div>

                :

                null
            }
        </Drawer>





    )
}

FichaClienteData.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    DATOS_CLIENTE_SELECCIONADO: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ID_USUARIO: PropTypes.number,
    DATOS_CLIENTE: PropTypes.object,
    ACTUALIZAR_LICENCIAS: PropTypes.func,
    TEXTO_BUSCADOR: PropTypes.func,

};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion
    };
}

export default connect(mapStateToProps)(FichaClienteData);